import React from 'react'
// Components
import { Icon } from '@navent-jobs/ui-kit/components/icon'

// Tools
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { useTranslation } from 'react-i18next'
import { SITE_ID, NOMBRE_PAIS, IS_ZONA_JOBS } from '../../../../../constants'

// Styles
import {
  ContentWrapper,
  CustomLink,
  Description,
  Image,
  ImageWrapper,
  Item,
  List,
  SubTitle,
  TextWrapper,
  Title,
} from './mixins'
import { DataLayer } from '../../../../../constants/gtm-events-home'

const LogedUserSuggest = () => {
  const { t } = useTranslation()
  const { isMobile, isTabletPortrait } = useWindowSize()

  const handleClick = () => {
    DataLayer.handlerIrPerfilTraking()
  }

  return (
    <ContentWrapper>
      <ImageWrapper>
        {/* La ruta no existe para ZonaJobs */}
        {!IS_ZONA_JOBS && (
          <Image
            bg={require(`./../../../../../assets/images/home/suggestion/usuario-logueado/${SITE_ID}/mejorar-perfil-${isMobile || isTabletPortrait ? 'mobile' : 'desktop'
              }.webp`)}
          />
        )}
      </ImageWrapper>
      <TextWrapper>
        <Title>{t('suggestionsHome.userLogged.title')}</Title>
        <SubTitle>{t('suggestionsHome.userLogged.subTitle')}</SubTitle>
        <List>
          <Item>
            <Icon name="icon-light-edit-1" size="24" color="#FFFF" />
            <Description>{t('suggestionsHome.userLogged.description1')}</Description>
          </Item>
          <Item>
            <Icon name="icon-light-updated" size="24" color="#FFFF" />
            <Description>{t('suggestionsHome.userLogged.description2')}</Description>
          </Item>
          <Item>
            <Icon name="icon-light-flash-on" size="24" color="#FFFF" />
            <Description>{t('suggestionsHome.userLogged.description3')}</Description>
          </Item>
          {NOMBRE_PAIS !== 'México' && (
            <Item>
              <Icon name="icon-light-rocket" size="24" color="#FFFF" />
              <Description>{t('suggestionsHome.userLogged.description4')}</Description>
            </Item>
          )}
        </List>
        <CustomLink href="/candidatos/curriculum" target="_blank" onClick={() => handleClick()}>
          {t('suggestionsHome.userLogged.cta')}
        </CustomLink>
      </TextWrapper>
    </ContentWrapper>
  )
}

export default LogedUserSuggest
